import { InteractionRequiredAuthError } from "msal";
import { azureAuthProvider } from "utility/authProvider";
import environment from "environment";

class MsalAuthServiceInternal {
	signIn = async (): Promise<void> => {
		await azureAuthProvider.login();
	};

	signOut = async (): Promise<void> => {
		await azureAuthProvider.logout();
	};

	getAuthToken = async () => {
		if (!azureAuthProvider.getAccount()) {
			return null;
		}

		const renewIdTokenRequest = {
			scopes: [environment.azureClientId],
		};
		azureAuthProvider
			.acquireTokenSilent(renewIdTokenRequest)
			.then((response) => {
				// send response.idToken to the backend
			})
			.catch((error) => {
				// if it is an InteractionRequired error, send the same request in an acquireToken call
				if (error instanceof InteractionRequiredAuthError) {
					azureAuthProvider.acquireTokenRedirect(renewIdTokenRequest);
				}
			});

		const authToken = await azureAuthProvider.getIdToken();
		return authToken ? authToken.idToken.rawIdToken : null;
	};
}
const MsalAuthService = new MsalAuthServiceInternal();
export default MsalAuthService;
